import { render, staticRenderFns } from "./ed-h2.vue?vue&type=template&id=7bd417d8&scoped=true&"
import script from "./ed-h2.ts?vue&type=script&lang=js&"
export * from "./ed-h2.ts?vue&type=script&lang=js&"
import style0 from "./ed-h2.scss?vue&type=style&index=0&id=7bd417d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd417d8",
  null
  
)

export default component.exports